/**
 * ชื่อภาษาไทยของสมรรถนะแต่ละด้าน
 *
 * ────────────────────────────────────────────────────────────────
 *  ทำไมอยู่ที่ domain ไม่ใช่ในไฟล์หน้าจอ
 * ────────────────────────────────────────────────────────────────
 *
 * คีย์ของสมรรถนะในไฟล์ข้อมูลเป็นภาษาอังกฤษแบบ camelCase (changeManagement)
 * ซึ่งอ่านไม่ได้บนหน้าจอภาษาไทย ตารางนี้จึงต้องอยู่ทุกที่ที่แสดงค่าสมรรถนะ
 *
 * เดิมมีสำเนาอยู่สองที่ (PersonCard.tsx กับ profilePdf.ts) พอหน้าเทียบผู้เข้าเงื่อนไข
 * ต้องใช้อีกที่ — และครั้งนี้เป็นฝั่งเซิร์ฟเวอร์ซึ่ง import ไฟล์หน้าจอไม่ได้ —
 * จึงย้ายมาไว้ที่เดียวแล้วให้ทุกฝั่งอ้างที่นี่ ไม่งั้นวันที่ต้นทางเพิ่มด้านใหม่
 * จะมีหน้าจอบางหน้าขึ้นชื่อไทยและบางหน้าขึ้นชื่ออังกฤษปนกันในระบบเดียว
 *
 * ⚠ ค่าคงที่ล้วนและไม่ import อะไรเลย จึงเอาไปใช้ฝั่งเบราว์เซอร์ได้โดยไม่มีโค้ด
 *   ของเซิร์ฟเวอร์ตามเข้าไปใน bundle (กฎเดียวกับ levels.ts)
 *
 * ⚠ ด้านที่ไม่มีในตารางนี้ต้องแสดงคีย์เดิมตามที่ได้มา ห้ามซ่อน
 *   การซ่อนทำให้ค่าที่อยู่ในแฟ้มจริงหายไปจากหน้าจอโดยไม่มีใครรู้
 */
export const COMPETENCY_TH: Record<string, string> = {
  leadership: 'ภาวะผู้นำ',
  strategicThinking: 'การคิดเชิงยุทธศาสตร์',
  changeManagement: 'การบริหารการเปลี่ยนแปลง',
  communication: 'การสื่อสาร',
  digitalLiteracy: 'ทักษะดิจิทัล',
  teamwork: 'การทำงานเป็นทีม',
};

/** ชื่อไทยของด้านนั้น — ไม่รู้จักก็คืนคีย์เดิม ไม่ใช่คืนค่าว่าง */
export function competencyLabel(key: string): string {
  return COMPETENCY_TH[key] ?? key;
}
